import {
    get, post
} from '@/utils/request'

const SERVICE_URL = '/project-service/v1'

/** 技术包通知管理 */
export function fetchTechList(params) { 
    return post(SERVICE_URL + '/plmTech/list', params)
}

// /** 技术包通知（弹窗） */
// export function fetchTechList2(params) {
//     return post(SERVICE_URL + '/tech/list2', params)
// }
export function deleteTech(params) {
    console.log(params)
    return post(SERVICE_URL + '/plmTech/deleteBatch', params)
}
export function createTechNoti(params) {
    return post(SERVICE_URL + '/plmTech/add', params)
}

export function getTechNotiById(params, pathParam) {
    return get(SERVICE_URL + '/plmTech/getById', params, pathParam)
}

export function editTechNoti(params) {
    return post(SERVICE_URL + '/plmTech/edit', params)
}

/** 接收或反馈 */
export function receiveOrFeedBackTech(params) {
    return post(SERVICE_URL + '/plmTech/callback2Plm', params)
}

export function getPlmTechnicalById(params, pathParam) {
    return get(SERVICE_URL + '/plmTech/getPlmTechnicalById', params, pathParam)
}

/** 获取plm项目 */
export function getPlmProject(params, pathParam) {
    return post(SERVICE_URL + '/plmTech/codeList', params, pathParam)
}

/** 获取plm车型 */
export function getPlmCar(params, pathParam) {
    return post(SERVICE_URL + '/plmTech/firstCarList', params, pathParam)
}

/** 采购端端获取为接收的plm定点申请数量 */
export function notReceivedPlmTechCount() {
    return get(SERVICE_URL + '/plmTech/notReceivedPlmTechCount')
}

/** 零件管理 */
export function getPartList(params) {
    return post(SERVICE_URL + '/plmPart/list', params)
}

export function getPartById(params, pathParam) {
    return get(SERVICE_URL + '/plmPart/getById', params, pathParam)
}

export function editPart(params) {
    return post(SERVICE_URL + '/plmPart/edit', params)
}

export function createPart(params) {
    return post(SERVICE_URL + '/plmPart/add', params)
}

export function createPartList(params) {
    return post(SERVICE_URL + '/plmPart/addList', params)
}

export function deletePart(params) {
    console.log(params)
    return post(SERVICE_URL + '/plmPart/deleteBatch', params)
}

export function getNoExistPartsByTechIdAndFactory(params, pathParam) {
    return post(SERVICE_URL + '/plmPart/getNoExistParts', params, pathParam)
}

// 任务列表零件
export function getTaskApparmentList(params) {
    return post(SERVICE_URL + '/part/listTaskPart', params)
}

export function getTaskPartIdsByTaskId(params, pathParam) {
    return get(SERVICE_URL + '/part/getTaskPartIdsByTaskId', params, pathParam)
}

export function deleteTaskApparmentByIds(params) {
    return post(SERVICE_URL + '/part/removeTaskPartByIds', params)
}

export function updateTaskApparmentByIds(params) {
    return post(SERVICE_URL + '/part/updateTaskPartByIds', params)
}


/** 供应商管理 */
export function getSupplierList(params) {
    return post(SERVICE_URL + '/plmSupplier/list', params)
}

export function deleteSupplier(params) {
    console.log(params)
    return post(SERVICE_URL + '/plmSupplier/deleteBatch', params)
}

export function getSupplierById(params, pathParam) {
    return get(SERVICE_URL + '/plmSupplier/getById', params, pathParam)
}

export function createSupplier(params) {
    return post(SERVICE_URL + '/plmSupplier/add', params)
}

export function editSupplier(params) {
    return post(SERVICE_URL + '/plmSupplier/edit', params)
}

/** 招标管理 */
export function getBiddingList(params) {
    return post(SERVICE_URL + '/plmBidding/list', params)
}

export function deleteBidding(params) {
    console.log(params)
    return post(SERVICE_URL + '/plmBidding/deleteBatch', params)
}

export function getBiddingById(params, pathParam) {
    return get(SERVICE_URL + '/plmBidding/getById', params, pathParam)
}

export function createBidding(params) {
    return post(SERVICE_URL + '/plmBidding/add', params)
}

export function createBiddings(params) {
    return post(SERVICE_URL + '/plmBidding/adds', params)
}

export function editBidding(params) {
    return post(SERVICE_URL + '/plmBidding/edit', params)
}

/** 招标模板管理 */
export function getBiddingTemplateList(params) {
    return post(SERVICE_URL + '/biddingTemplate/list', params)
}

// export function deleteBidding(params) {
//     console.log(params)
//     return post(SERVICE_URL + '/bidding/deleteBatch', params)
// }

// export function getBiddingById(params, pathParam) {
//     return get(SERVICE_URL + '/bidding/getById', params, pathParam)
// }

// export function createBidding(params) {
//     return post(SERVICE_URL + '/bidding/add', params)
// }

// export function editBidding(params) {
//     return post(SERVICE_URL + '/bidding/edit', params)
// }

export function importFile(params) {
    return importData(SERVICE_URL + '/part/import', params)
}

/** 审批历史管理 */
export function getApprovalList(params) {
    return post(SERVICE_URL + '/plmTechApproveHistory/list', params)
}

/** 未下载的附件 */
export function getNoDownloadFileList(params) {
    return post(SERVICE_URL + '/plmTechnicalFileEntity/noDownLoadFileList', params)
}

export function downloadFile(params) {return get(SERVICE_URL + '/plmTech/downloadFileById', params)}

/** 查找分配任务中对应的定点申请接收数据 */
export function getPlmTechnicalCountByPT(params) {
    return post(SERVICE_URL + '/plmTech/getPlmTechnicalCountByPT', params)
}
export function projectCodeSelect(params) {
   return post(SERVICE_URL + '/project/projectCodeSelect', params)
}
export function CarTypeSelect(params) {
       return post(SERVICE_URL + '/project/CarTypeSelect', params)
}
